import { USER_DATA_API } from "../../apiList";
import TypeString from "../valueObject/TypeString";

export default class PropertyVendorGateway {
    getAll(id: TypeString) {
        return USER_DATA_API.get(`/property-vendors/${id.value}`);
    }
}
